/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ConfigureDirectDebitPreferencesRequest} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/direct_debit_preferences.pb'
import {ConfigureDirectDebitPreferencesResponse} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/direct_debit_preferences.pb'


export const configureDirectDebitPreferences = (request: ConfigureDirectDebitPreferencesRequest, options?: CashRequestOptions) => post<ConfigureDirectDebitPreferencesRequest, ConfigureDirectDebitPreferencesResponse>("/2.0/cash/configure-direct-debit-preferences", request, {...options, rejectOnError: true })